import cx from 'classnames';
import { CatGrid } from '@blocks-react/components/Grid';
import { CatGridItem } from '@blocks-react/components/GridItem';
import { CatHeading } from '@blocks-react/components/Heading';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import NoHtmlContent from '../../../common/noHtmlContent/noHtmlContent';
import { useBreakpoint } from '../../../../hooks';
import { instanceProps, ServiceTranslationProps } from '../../types';
import styles from '../../serviceRecommendation.module.scss';

type ServiceRecommendationImpactSectionProps = {
  impactSectionData: instanceProps;
  ServiceModalTranslations: {
    impactTitle: ServiceTranslationProps['impactTitle'];
    recommendationTitle: ServiceTranslationProps['recommendationTitle'];
  };
};

export const ServiceRecommendationImpactSection = ({
  impactSectionData,
  ServiceModalTranslations
}: ServiceRecommendationImpactSectionProps) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <CatGrid gap={isMD ? 'sm' : 'lg'}>
      <CatGridItem className="d-flex flex-column">
        <CatHeading
          level="h6"
          variant="label-lg"
          className={styles['service_recommendation_label']}
        >
          {ServiceModalTranslations.impactTitle}
        </CatHeading>
        <div
          className={cx('cat-u-theme-typography-body-sm', 'vh-10', [
            styles['description_section']
          ])}
        >
          <NoHtmlContent content={impactSectionData?.impact} />
        </div>
      </CatGridItem>
      <CatGridItem className="d-flex flex-column">
        <CatHeading
          level="h6"
          variant="label-lg"
          className={styles['service_recommendation_label']}
        >
          {ServiceModalTranslations.recommendationTitle}
        </CatHeading>
        <div
          className={cx('cat-u-theme-typography-body-sm', 'vh-50', [
            styles['description_section']
          ])}
          dangerouslySetInnerHTML={{
            __html: impactSectionData?.recommendation
          }}
        />
      </CatGridItem>
    </CatGrid>
  );
};
